export default (course) =>
  `${course?.title} will be removed from the list of user’s courses. Do you confirm this action?`;
